import {
  createAsyncThunk,
  createSelector,
  createSlice
} from '@reduxjs/toolkit'

const sliceName = 'profile'
const selectors = {}
const thunks = {}

selectors.selectUserFeatures = createSelector(
  (state) => state[sliceName].user,
  (user) => user.features
)

thunks.fetch = createAsyncThunk(
  `${sliceName}/fetch`,
  async ({ includeAccount = false }, thunkAPI) => {
    // TODO: Add API interface for this request and actually fetch.
  }
)

const slice = createSlice({
  name: sliceName,
  initialState: {
    account: {},
    participant: {},
    user: {}
  },
  reducers: {
    manuallyUpdated (state, action) {
      const { account, participant, user } = action.payload
      state.account = account || state.account
      state.participant = participant || state.participant
      state.user = user || state.user
    }
  },
  extraReducers (builder) {
  }
})

const sliceExport = {
  name: sliceName,
  reducer: slice.reducer,
  ...slice.actions,
  ...selectors,
  ...thunks
}

export { sliceExport as slice }
